import { render } from "./Index.vue?vue&type=template&id=b144c6dc&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=b144c6dc&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=b144c6dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b144c6dc"

export default script